import { Link } from "../../components/util";
import { urls } from "../../config/appConfig";
import * as Styled from "./styles.css";

const AuthFooter = () => {
  return (
    <Styled.FooterTypography
      variant="body2"
      styled={{ text: { shade: "weak" } }}
    >
      By continuing, you agree to Care’s{" "}
      <Link href={urls.careTerms} isNewTab>
        terms
      </Link>{" "}
      and{" "}
      <Link href={urls.carePrivacy} isNewTab>
        privacy policy
      </Link>
      .
    </Styled.FooterTypography>
  );
};

export default AuthFooter;
